import {HallFilter} from "../types/filters";
import {HallsActionTypes} from "./actionTypes";
import {GameRTPProfilePayload} from "../../configurations/components/Utils/rtp-profiles";

export const HallsActionCreators = {
    getHallsList: ({page = 0, search = null, top = 10, filters = null}) => ({
        type: HallsActionTypes.GET_HALLS_LIST,
        payload: {page, search, top, filters}
    }),

    getHall: ({hallId}: { hallId: number }) => ({
        type: HallsActionTypes.GET_HALL,
        payload: {hallId}
    }),

    cleanInspectingServer: () => ({
        type: HallsActionTypes.CLEAN_SERVER
    }),

    getServers: ({hallId, search = null, status = null, version = null}) => ({
        type: HallsActionTypes.GET_SERVERS,
        payload: {
            hallId,
            search,
            status,
            version
        }
    }),

    getServer: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.GET_SERVER,
        payload: {
            serverId
        }
    }),

    updateCreationMode: mode => ({
        type: HallsActionTypes.CREATION_MODE_CHANGE,
        payload: {
            mode
        }
    }),

    uploadConfiguration: (
        subsidiary,
        server_type,
        server_id,
        system_version,
        file
    ) => ({
        type: HallsActionTypes.UPLOAD_CONFIGURATION,
        payload: {
            subsidiary,
            server_type,
            server_id,
            system_version,
            file
        }
    }),

    getSubsidiaries: () => ({
        type: HallsActionTypes.GET_SUBSIDIARIES
    }),

    changeHallListFilter: (filters: HallFilter[]) => ({
        type: HallsActionTypes.CHANGE_HALL_LIST_FILTER,
        payload: filters
    }),

    clearHallListFilters: (requestHalls: boolean = true) => ({
        type: HallsActionTypes.CLEAR_HALL_LIST_FILTERS,
        payload: requestHalls
    }),

    clearHallListFilter: filterType => ({
        type: HallsActionTypes.CLEAR_HALL_LIST_FILTER,
        payload: filterType
    }),

    getConfigurationsList: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.GET_CONFIGURATIONS_LIST,
        payload: {
            serverId
        }
    }),

    updateCreatingHall: (values, isValid) => ({
        type: HallsActionTypes.UPDATE_CREATING_HALL,
        payload: {
            values,
            isValid
        }
    }),

    updateMapCoordinates: (lat, lon) => ({
        type: HallsActionTypes.UPDATE_MAP_COORDINATES,
        payload: {
            lat,
            lon
        }
    }),

    createHall: hallInfo => ({
        type: HallsActionTypes.CREATE_HALL,
        payload: hallInfo
    }),

    clearCreateHall: () => ({
        type: HallsActionTypes.CREATE_HALL_RESET
    }),

    updateHall: (hallId, hallName, newState) => ({
        type: HallsActionTypes.UPDATE_HALL,
        payload: {
            hallId,
            hallName,
            newState
        }
    }),

    pickSuggestion: suggestion => ({
        type: HallsActionTypes.PICK_SUGGESTION,
        payload: {
            suggestion
        }
    }),

    createServer: ({hallId, type, system_server_version, name/*, perpetual_license*/,secure_connection,  is_egames = false, filter = null}) => ({
        type: HallsActionTypes.CREATE_SERVER,
        payload: {
            hallId,
            type,
            system_server_version,
            name,
            secure_connection,
            is_egames,
            //perpetual_license,
            filter
        }
    }),
    cloneServer: ({id, system_server_version, secure_connection = false, is_egames = false, hallId, filter = null}) => ({
        type: HallsActionTypes.CLONE_SERVER,
        payload: {
            id,
            system_server_version,
            secure_connection,
            is_egames,
            hallId,
            filter
        }
    }),
    /* getCashingSystems: () => ({
        type: HallsActionTypes.GET_CASH_SYSTEMS
    }), */

    getTimezones: subsidiaryCountry => ({
        type: HallsActionTypes.GET_TIMEZONES,
        payload: {
            subsidiaryCountry
        }
    }),

    getCoreVersions: () => ({
        type: HallsActionTypes.GET_CORE_VERSIONS
    }),

    activateHall: hallId => ({
        type: HallsActionTypes.TOGGLE_HALL_ACTIVE,
        payload: {
            hallId: hallId
        }
    }),

    deleteHall: hallId => ({
        type: HallsActionTypes.DELETE_HALL,
        payload: {
            hallId: hallId
        }
    }),

    activateServer: serverId => ({
        type: HallsActionTypes.TOGGLE_SERVER_ACTIVE,
        payload: {
            serverId: serverId
        }
    }),

    toggleServerDebugMode: serverId => ({
        type: HallsActionTypes.TOGGLE_SERVER_DEBUG_MODE,
        payload: {
            serverId: serverId
        }
    }),

    toggleServerPerpetualLicense: serverId => ({
        type: HallsActionTypes.TOGGLE_SERVER_PERPETUAL_LICENSE,
        payload: {
            serverId: serverId
        }
    }),

    updateServer: ({id, name, hallId, filter = null}) => ({
        type: HallsActionTypes.UPDATE_SERVER,
        payload: {
            id,
            name,
            hallId,
            filter
        }
    }),

    getCompareConfigurations: ({confIds, hall, server}) => ({
        type: HallsActionTypes.GET_COMPARE_CONFIGURATIONS,
        payload: {
            confIds, hall, server
        }
    }),

    clearCompareConfigs: () => ({
        type: HallsActionTypes.GET_COMPARE_CONFIGURATIONS_CLEAR
    }),

    getServerLicense: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.GET_SERVER_LICENSE,
        payload: {serverId}
    }),

    getServerLicenseState: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.GET_SERVER_LICENSE_STATE,
        payload: {serverId}
    }),

    initLicenseWithUpload: ({
                                serverId,
                                file
                            }: {
        serverId: number;
        file: any;
    }) => ({
        type: HallsActionTypes.UPLOAD_LICENSE_SEED,
        payload: {serverId, file}
    }),

    rejectLicenseID: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.REJECT_LICENSE_ID,
        payload: {serverId}
    }),

    confirmLicenseID: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.CONFIRM_LICENSE_ID,
        payload: {serverId}
    }),

    updateLicenseDuration: ({
                                serverId,
                                duration
                            }: {
        serverId: number;
        duration: number;
    }) => ({
        type: HallsActionTypes.UPDATE_LICENSE_DURATION,
        payload: {serverId, duration}
    }),

    clearUpdateDuration: () => ({
        type: HallsActionTypes.CLEAR_LICENSE_DURATION
    }),

    cancelLicenseProcess: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.CANCEL_LICENSE_PROCESS,
        payload: {serverId}
    }),

    getLicenseDownload: ({
                             serverId,
                             serverName
                         }: {
        serverId: number;
        serverName: string;
    }) => ({
        type: HallsActionTypes.GET_LICENSE_DOWNLOAD,
        payload: {serverId, serverName}
    }),

    setLicenseApplied: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.SET_LICENSE_APPLIED,
        payload: {serverId}
    }),

    renewLicense: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.RENEW_LICENSE,
        payload: {
            serverId
        }
    }),

    updateRemotelyLicense: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.UPDATE_REMOTELY_LICENSE,
        payload: {
            serverId
        }
    }),

    invalidateLicense: ({serverId}: { serverId: number }) => ({
        type: HallsActionTypes.INVALIDATE_LICENSE,
        payload: {
            serverId
        }
    }),

    getLicenseActivity: ({serverId, page = 0, top = 10}) => ({
        type: HallsActionTypes.GET_LICENSE_ACTIVITY,
        payload: {
            serverId,
            page,
            top
        }
    }),

    uploadSystemSpec: ({
                           serverId,
                           file
                       }: {
        serverId: number;
        file: any;
    }) => ({
        type: HallsActionTypes.UPLOAD_SYSTEM_SPECIFICATION,
        payload: {serverId, file}
    }),

    clearSuccessUploadSpec: () => ({
        type: HallsActionTypes.REMOVED_SPECIFICATION_SELECTION
    }),

    getSpecificationActivity: ({serverId, page = 0, top = 10}) => ({
        type: HallsActionTypes.GET_SPECIFICATION_ACTIVITY,
        payload: {
            serverId,
            page,
            top
        }
    }),

    getDynamicHall: subsidiary => ({
        type: HallsActionTypes.GET_DYNAMIC_HALL,
        payload: {
            subsidiary
        }
    }),

    getDynamicHallInfo: hallCode => ({
        type: HallsActionTypes.GET_DYNAMIC_HALL_INFO,
        payload: {
            hallCode
        }
    }),

    clearDynamicHallInfo: () => ({
        type: HallsActionTypes.CLEAR_DYNAMIC_HALL_INFO
    }),

    getProductionServer: () => ({
        type: HallsActionTypes.GET_PRODUCTION_INFO
    }),

    uploadConfigurationRemotely: ({
        serverId,
        update_time = null,
        include_server_config = true,
        include_game_logos = true,
        game_rtp_profiles = []
    }: {
        serverId: number;
        update_time?: string;
        include_server_config?: boolean;
        include_game_logos?: boolean;
        game_rtp_profiles?: GameRTPProfilePayload[];
    }) => ({
        type: HallsActionTypes.UPLOAD_CONFIGURATION_REMOTELY,
        payload: {
            serverId,
            update_time,
            include_server_config,
            include_game_logos,
            game_rtp_profiles
        }
    }),
};
